<template>
  <Wrap>
    <div class="inner">
      <SkeletonItem
        v-if="loading"
        class="breadcrumbs-skeleton"
        is-animated
      />
      <Breadcrumbs
        v-else-if="crumbs.length"
        :breadcrumbs="crumbs"
        :events-identifier="eventsIdentifier"
        :track-event="breadcrumbsTrackEvent"
      />
    </div>
  </Wrap>
</template>

<script setup lang="ts">
  import Wrap from '@/shared/ui/Wrap.vue';
  import { SkeletonItem } from '@experience/core-skeleton-lib';
  import { Breadcrumbs, type Breadcrumb, type TrackEvent } from '@experience/core-breadcrumbs-ui';
  import { trackEvent } from '@/services/analytics';
  import { ref, computed } from 'vue';
  import type { Geo } from '@/shared/models/journal';

  interface Props {
    geo: Geo;
  }

  const props = defineProps<Props>();

  const loading = ref(false);
  const breadcrumbsTrackEvent = trackEvent as TrackEvent;
  const crumbs = computed<Breadcrumb[]>(() => {
    const items: Breadcrumb[] = [{ label: 'Журнал', to: '/journal' }];
    const country = props.geo?.country?.[0];
    const city = props.geo?.city?.[0];
    if (country) {
      items.push({ label: country.name, to: country.url });
    }
    if (city) {
      items.push({ label: city.name, to: city.url });
    }
    return items;
  });

  const eventsIdentifier = 'article-page';
</script>

<style lang="scss" scoped>
  .breadcrumbs-skeleton {
    width: 260px;
    height: 34px;
    margin: 7px 1px;

    @include tablet {
      width: 100px;
    }
  }

  .inner {
    padding: 24px 0 0;

    @include tablet {
      padding: 16px 0 0;
    }
  }
</style>
